import React, { useContext, useEffect, useState } from 'react'
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import popupStyle from "../../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss";
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import contactStyles from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import workflowStyles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss"
import workflowFormStyles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss"
import waCampaignStyles from "../../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import textAreaStyles from '../../../../../../assets/styles/componentStyles/templates.module.scss'
import { Autocomplete, Chip, Divider, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import { customVariableDataInterface, talkToAgentPayload } from '../../../../../../models/axiosModel';
import { operatorType } from '../../../../../../models/flowBuilderTypes';
import { checkConditionValidation, emptyConditionGroupObj, emptyCustomVariableConditionObj, getCustomVariableById, getDefaultValueOfTalkToAgentPayload, getOperatorTypeById, isAssignmentStrategyTypeRandom, operatorTypesWithEmptyValue } from '../../../flowBuilderConstants';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext';
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';
import CloseIcon from '@mui/icons-material/Close';
import GlobalButton from '../../../../../utility/globalButton/button';
import { checkValidRegex } from '../../../../../../utils/constants';
import Required from '../../../../../utility/required';
import RenderFormControlLabel from './renderFormControlLabel';
import IconsColor from '../../../../../utility/iconsColor';
import { redColor } from '../../../../../../utils/colors';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

interface TalkToAgentPopupProps {
    actionData: any,
    stepAction: any,
    setFlagAssignAgentPopup: React.Dispatch<React.SetStateAction<boolean>>,
}

type combinedValueType = "variable" | "operator" | "value" | "freesolo value" | "condition switch";
type combinedUpdateType =
    | { type: "condition switch", value: string }
    | { type: "variable", value: customVariableDataInterface | null }
    | { type: "operator", value: operatorType | null }
    | { type: "value", value: string }

const TalkToAgentPopup: React.FC<TalkToAgentPopupProps> = (props) => {

    const { actionData, stepAction, setFlagAssignAgentPopup } = props;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;
    const { nodes, edges, onBlurOfFallBackOfBtnVar, currentActiveNodeConfig, operatorList, getOperatorTypeApi, onChangeCurrentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload

    const isSourceHandleConnected = edges?.find((edge: any) => edge?.sourceHandle == stepAction?.chatbot_step_id);

    const [payload, setPayload] = useState<talkToAgentPayload>(getDefaultValueOfTalkToAgentPayload(actionData, isSourceHandleConnected))
    const [typedConditionValue, setTypedConditionValue] = useState<string>("");

    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    const assignmentStrategyTypeData = useFlowBuilderStore((state) => state.assignmentStrategyTypeData);
    const getAssignmentStrategyTypeApi = useFlowBuilderStore((state) => state.getAssignmentStrategyTypeApi);

    const getOperatorTypeApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getOperatorTypeApi();
        if (!(res.status)) {
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const getAssignmentStrategyTypeApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getAssignmentStrategyTypeApi();
        if (!(res.status)) {
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        if (!assignmentStrategyTypeData) {
            getAssignmentStrategyTypeApiCall();
        }

        if (!operatorList) {
            getOperatorTypeApiCall();
        }
    }, []);

    const getValueOfFields = (type: combinedValueType) => {
        const { condition_group } = payload;

        switch (type) {
            case "condition switch":
                return condition_group ? true : false;
            case "operator":
                return getOperatorTypeById(operatorList, condition_group?.custom_variable_conditions?.operator_type_id);
            case "freesolo value":
                return (condition_group?.custom_variable_conditions?.condition_value || "")?.split(",")?.map((item: string) => item?.trim())?.filter((item: string) => item?.length > 0) ?? [];
            case "value":
                return condition_group?.custom_variable_conditions?.condition_value || "";
            case "variable":
                return getCustomVariableById(customVariableList, condition_group?.custom_variable_conditions?.chatbot_custom_variable_configuration_id) ?? null;
        }
    }

    const onChangeOfFields = ({ type, value }: combinedUpdateType) => {
        setPayload((prev) => {
            let newPayload = { ...prev };

            const baseConditions = prev?.condition_group ? prev?.condition_group?.custom_variable_conditions : emptyCustomVariableConditionObj;
            let updatedConditions = baseConditions;

            switch (type) {
                case "condition switch":
                    return {
                        ...newPayload,
                        condition_group: value == "true" ? emptyConditionGroupObj : null,
                        condition_group_id: value == "true" ? "" : null
                    }
                case "variable":
                    updatedConditions = {
                        ...baseConditions,
                        chatbot_custom_variable_configuration_id:
                            value ? value.chatbot_custom_variable_configuration_id : "",
                    };
                    break;
                case "operator":
                    const opVal = value as operatorType | null;

                    updatedConditions = {
                        ...baseConditions,
                        operator_type_id: opVal ? opVal.operator_type_id : "",
                        operator_type_name: opVal ? opVal.operator_type_name : "",
                    };

                    // Empty value operators
                    if (opVal && operatorTypesWithEmptyValue.includes(opVal.operator_type_name)) {
                        updatedConditions.condition_value = "";
                    }
                    break;
                case "value":
                    updatedConditions = {
                        ...baseConditions,
                        condition_value: value as string,
                    };
                    break;
            }

            return {
                ...newPayload,
                condition_group: {
                    ...(newPayload?.condition_group ?? emptyConditionGroupObj),
                    custom_variable_conditions: updatedConditions,
                }
            }
        })
    }

    const shouldRenderOperandField = () => {
        return operatorTypesWithEmptyValue?.includes((getValueOfFields("operator") as operatorType | null)?.operator_type_name?.toLowerCase() ?? "");
    }

    const trimFreeSoloValueAndFilterAndJoin = (newVal: string[]) => {
        return newVal?.map((item) => item?.trim())?.filter((item) => item.length > 0)?.join(", ") ?? "";
    }

    const onBlurOfFreeSoloAutoCompleteTextField = () => {
        if (typedConditionValue.trim()?.length > 0) {
            const currentVal = getValueOfFields("freesolo value") as string[];
            if (!currentVal.find((val: string) => val == typedConditionValue?.trim())) {
                const newVal = [...currentVal, typedConditionValue.trim()];
                onChangeOfFields({ type: "value", value: trimFreeSoloValueAndFilterAndJoin(newVal) })
                setTypedConditionValue("");
            }
        }
    }

    const onClickOfSaveBtn = () => {
        const updateTalkToAgentObj = {
            condition_group: payload?.condition_group,
            condition_group_id: payload?.condition_group_id,
            assignment_strategy_type: assignmentStrategyTypeData?.find((strategy) => isAssignmentStrategyTypeRandom(strategy?.assignment_strategy_type_name)) ?? null,
        }

        const editStepActionObj = {
            updateType: "editExistingStepAction"
        }

        onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction?.chatbot_step_action_id, updateTalkToAgentObj, editStepActionObj);
        onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction?.chatbot_step_action_id, updateTalkToAgentObj, editStepActionObj);
        setFlagAssignAgentPopup(false);
    }

    const checkDisableSaveBtn = () => {
        if (isCurrentViewVersionPublished(currentActiveStaticWorkflow)) return true;
        if (!payload?.condition_group) return isSourceHandleConnected;

        return checkConditionValidation(payload?.condition_group?.custom_variable_conditions);
    }

    const showRemoveEdgeWarning = () => {
        return isSourceHandleConnected && !payload?.condition_group;
    }

    return (
        <>
            <Grid container className={`${globalStyles.fullHeight} ${globalStyles.zIndex1} ${globalStyles.flexColumn}`} gap={"20px"} padding={"30px"} flexWrap={"nowrap"}>
                <Grid item className={`${globalStyles.fullwidth} ${globalStyles.textCenter}`}>
                    <span className={popupStyle.popupTitleStyle}>
                        Assign Agent
                    </span>
                </Grid>
                <Grid item>
                    <Divider className={workflowFormStyles.resetVariableDivider} />
                </Grid>

                <Grid item className={`${globalStyles.fullwidth}`}>
                    <Grid container gap={1}>
                        <Grid item xs={12}>
                            <Typography className={styles.createWorkflowLabelStyle}>How do you want to assign the agent?</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="assign-agent-type-radio-buttons-group-label"
                                    defaultValue=""
                                    name="assign-agent_type-radio-buttons-group"
                                    value={getValueOfFields("condition switch") as boolean}
                                    onChange={(event) => onChangeOfFields({ type: "condition switch", value: event.target.value })}
                                >
                                    {RenderFormControlLabel("Always assign", false)}
                                    {RenderFormControlLabel("Assign based on condition", true)}
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>

                {getValueOfFields("condition switch") &&
                    <Grid item xs={12}>
                        <Grid container gap={"12px"}>
                            <Grid item xs={12}>
                                <Grid container gap={1} flexWrap={"nowrap"}>
                                    <Grid item xs={shouldRenderOperandField() ? 6 : 4.5}>
                                        <Grid container className={`${globalStyles.flexColumn}`} gap={"3px"}>
                                            <Grid item>
                                                <Typography className={contactStyles.popupFieldTypography}>Variable <Required /></Typography>
                                            </Grid>
                                            <Grid>
                                                <Autocomplete
                                                    className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                                    options={customVariableList?.custom_variable_data || []}
                                                    getOptionLabel={(option) => option.chatbot_custom_variable_name}
                                                    value={getValueOfFields("variable") as customVariableDataInterface | null}
                                                    onChange={(_, value: customVariableDataInterface | null) => onChangeOfFields({ type: "variable", value: value })}
                                                    renderInput={(params) => <TextField {...params} placeholder='Select Variable' />}
                                                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={shouldRenderOperandField() ? 6 : 3}>
                                        <Grid container className={`${globalStyles.flexColumn}`} gap={"3px"}>
                                            <Grid item>
                                                <Typography className={contactStyles.popupFieldTypography}>Operator <Required /></Typography>
                                            </Grid>
                                            <Grid>
                                                <Autocomplete
                                                    className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                                    options={operatorList?.filter((operator) => operator.is_active) || []}
                                                    getOptionLabel={(option) => option.operator_type_name}
                                                    value={getValueOfFields("operator") as operatorType | null}
                                                    onChange={(_, value: operatorType | null) => { onChangeOfFields({ type: "operator", value: value }) }}
                                                    renderInput={(params) => <TextField {...params} placeholder='Operator' />}
                                                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    {!shouldRenderOperandField() &&
                                        <Grid item xs={4}>
                                            <Grid container className={`${globalStyles.flexColumn}`} gap={"3px"}>
                                                <Grid item>
                                                    <Typography className={contactStyles.popupFieldTypography}>Value <Required /></Typography>
                                                </Grid>
                                                <Grid>
                                                    {(getValueOfFields("operator") as operatorType | null)?.operator_type_name?.toLowerCase() == "contains in array" ?
                                                        <Autocomplete
                                                            className={`${waCampaignStyles.whatsappCampaignDropDowns} ${globalStyles.fullwidth} ${waCampaignStyles.actionAutoComplete} ${waCampaignStyles.actionUserReplyAutoComplete} ${styles.triggerValueFreeSolo} ${styles.conditionValueFreeSolo}`}
                                                            freeSolo
                                                            options={[]}
                                                            multiple
                                                            value={getValueOfFields("freesolo value") as string[]}
                                                            inputValue={typedConditionValue}
                                                            onInputChange={(e, val) => setTypedConditionValue(val)}
                                                            renderTags={(value, getTagProps) =>
                                                                value.map((option, index) => (
                                                                    <Chip
                                                                        label={option}
                                                                        deleteIcon={<CloseIcon />}
                                                                        {...getTagProps({ index })}
                                                                        className={styles.containsInArrayFieldChip}
                                                                    />
                                                                ))
                                                            }
                                                            onChange={(e, newValue) => {
                                                                const validTrimmedValues = newValue.filter((val) => typeof val === "string" && val.trim().length > 0);
                                                                onChangeOfFields({ type: "value", value: trimFreeSoloValueAndFilterAndJoin(validTrimmedValues) })
                                                            }}
                                                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                            renderInput={params => {
                                                                const { InputProps, ...restParams } = params;
                                                                const { startAdornment, ...restInputProps } = InputProps;
                                                                return (
                                                                    <TextField
                                                                        {...restParams}
                                                                        placeholder='Enter Value'
                                                                        onBlur={() => onBlurOfFreeSoloAutoCompleteTextField()}
                                                                        InputProps={{
                                                                            ...restInputProps,
                                                                            startAdornment: (
                                                                                <div className={waCampaignStyles.renderInputDivOfUserReplyOfAction}>
                                                                                    {startAdornment}
                                                                                </div>
                                                                            ),
                                                                        }}
                                                                    />
                                                                );
                                                            }}
                                                        />
                                                        :
                                                        <textarea
                                                            value={getValueOfFields("value") as string}
                                                            onChange={(e) => {
                                                                onChangeOfFields({ type: "value", value: e.target.value })
                                                            }}
                                                            placeholder="Enter Value"
                                                            className={`${textAreaStyles.templateGlobalTextarea} ${styles.conditionValueTextArea}`}
                                                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                        />
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }

                {showRemoveEdgeWarning() &&
                    <Grid item className={`${globalStyles.fullwidth}`}>
                        <Grid container className={`${styles.removeEdgeWarningGrid}`} gap={1}>
                            <Grid item className={globalStyles.displayFlexStyle}>
                                <ErrorOutlineOutlinedIcon className={styles.removeEdgeWarningIcon} />
                            </Grid>
                            <Grid item>
                                <Typography className={`${styles.removeEdgeWarningTitle} ${globalStyles.tertiaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                                    You currently have an outgoing edge from this node. <br /> <br />
                                    If "Always Assign" is enabled, the conversation is handed over to an agent and the bot will not continue.
                                    Please delete the outgoing edge or switch to Conditional Assignment.
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                }

                <Grid item className={globalStyles.fullwidth} xs={12}>
                    <Grid container gap={"12px"} mt={2} mb={3} justifyContent={"center"} alignItems={"center"}>
                        <Grid item>
                            <GlobalButton
                                buttonText="Cancel"
                                className='borderedButtonStyle'
                                sx={{ width: "120px" }}
                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => setFlagAssignAgentPopup(false)}
                            />
                        </Grid>
                        <Grid item>
                            <GlobalButton
                                buttonText="Save"
                                className='primaryButtonStyle'
                                sx={{ width: "120px" }}
                                disabled={checkDisableSaveBtn()}
                                onClick={() => onClickOfSaveBtn()}
                            />
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </>
    )
}

export default TalkToAgentPopup
